import { render, staticRenderFns } from "./doctorSalary.vue?vue&type=template&id=38e01770&scoped=true"
import script from "./doctorSalary.vue?vue&type=script&lang=js"
export * from "./doctorSalary.vue?vue&type=script&lang=js"
import style0 from "./doctorSalary.vue?vue&type=style&index=0&id=38e01770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e01770",
  null
  
)

export default component.exports